/**
 * Turn a registry slug into a plain noun phrase for a chip label:
 * `carrier-services` → "Carrier services", `load_exception` → "Load exception".
 * Only the first character is capitalised; the rest keeps the slug's case so
 * acronyms such as `dat-posting` do not become "Dat Posting".
 */
export function humanizeSlug(slug: string): string {
  const words = slug.trim().replace(/[-_]+/g, " ").replace(/\s+/g, " ").trim();
  if (words.length === 0) return slug;
  return words.charAt(0).toUpperCase() + words.slice(1);
}
